import { AbortTaskRequest } from '@eggplant/api-requests'
import {
  ConfirmActionDialog,
  SuccessMessage
} from '@eggplant/pattern-library'
import { useConfigTypeTitle } from '@eggplant/routing'
import { useState } from 'react'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = { width: 500 }

interface Props {
  onCancel: () => void
  onSuccess: () => void
  taskInstanceId: string
}

const TaskAbort = ({
  onSuccess,
  onCancel,
  taskInstanceId
}: Props) => {
  const [isAborting, setIsAborting] = useState(false)
  const configTypeText = useConfigTypeTitle()

  const handleConfirm = () => {
    setIsAborting(true)
  }

  return (
    <div style={wrapperStyle}>
      {
        isAborting
          ? (
            <AbortTaskRequest
              onSuccess={onSuccess}
              taskInstanceId={taskInstanceId}
            >
              {
                () =>
                  <SuccessMessage>
                    Abort successfully requested.
                  </SuccessMessage>
              }
            </AbortTaskRequest>
          )
          : (
            <ConfirmActionDialog
              actionText='Stop run'
              message={`This will stop the ${configTypeText} configuration run and return a cancelled status for the run. This action cannot be undone.`}
              onCancel={onCancel}
              onConfirm={handleConfirm}
              title={`Stop ${configTypeText} configuration run?`}
            />
          )
      }
    </div>
  )
}

export default TaskAbort
